import classNames from 'classnames';
import { ClockIcon } from '@repo/icons';
import { tr } from '@repo/locale';
import { formatDuration } from '@repo/date-time';

import type { ParkingDurationCardProps } from '@shared/types';
import DurationCard from '@shared/components/duration/DurationCard';

export default function DurationCustomCard({
  minutes,
  testId,
  onClick,
  color,
  compact,
  className,
}: ParkingDurationCardProps) {
  return (
    <DurationCard
      testId={testId}
      className={classNames('col-span-2 min-w-0', className, { 'p-4': !compact, 'p-2': compact })}
      onClick={onClick}
      color={color}
      compact={compact}
    >
      <div
        className={classNames('min-w-0 flex-1 truncate text-base leading-4', {
          'text-brand': color === 'brand',
          'text-heading': color === 'white',
        })}
      >
        {formatDuration(minutes)} +
      </div>
      <div className="text-heading flex shrink-0 items-center justify-end gap-1.5 text-base leading-6 font-medium whitespace-nowrap">
        <ClockIcon size={16} />
        <div
          className={classNames('text-base leading-4', {
            'mr-1': !compact,
            'mr-0': compact,
            'text-brand': color === 'brand',
            'text-heading': color === 'white',
          })}
        >
          {tr('parking_search:park_duration.custom_time')}
        </div>
      </div>
    </DurationCard>
  );
}
